// Функция для получения цвета игрока в CSS формате
import {COLORS_CONFIG} from "../../configs/colors";
import {NEUTRAL_PLAYER_COLOR} from "../../constants/players";

export const getPlayerHexColor = (color) => {
  return COLORS_CONFIG[color] || '#FFFFFF';
};

/**
 * Цвет нейтрала — чистый черный, и на темных панелях (футер партии) он
 * сливается с фоном: там подставляем цвет иконок поверхности, тот же, которым
 * красятся маски (--icon-color, см. MaskedIcon и Footer.css). На светлых
 * страницах переменной нет, и запасное значение оставляет прежний черный.
 * Цвета остальных игроков видны на любой подложке и берутся как раньше.
 *
 * @param {string} color - цвет игрока (PLAYER_COLORS)
 * @returns {string} значение для CSS-свойства color/background-color
 */
export const getPlayerSurfaceColor = (color) => (
  color === NEUTRAL_PLAYER_COLOR
    ? `var(--icon-color, ${COLORS_CONFIG[NEUTRAL_PLAYER_COLOR]})`
    : getPlayerHexColor(color)
);
